// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Map__wrapper___Igccl","initialized":"Map__initialized___2GV27"};